import { observer } from 'mobx-react-lite';
import React from 'react';
import CustomFieldForm from '../../input/CustomFieldForm';
import SectionTitle from '../../content/SectionTitle';
import { CustomFieldContract } from '../../../types/CustomField';
import { useMst } from '../../../models/stores/Root';

export type CustomFieldSectionProps = {
  onErrorStatus?: (hasError: boolean) => void;
  customFields: CustomFieldContract[];
  useContext?: boolean;
};

const CustomFieldSection: React.FC<CustomFieldSectionProps> = observer(
  ({ onErrorStatus, customFields, useContext }: CustomFieldSectionProps) => {
    const { cart } = useMst();
    const handleOnValidData = (id: number, value: string): void => {
      if (!useContext) {
        cart.updateCustomField(id, value);
      }
    };

    return customFields.length < 1 ? null : (
      <div>
        <SectionTitle>Additional Info</SectionTitle>
        <CustomFieldForm
          customFields={customFields}
          onValidData={handleOnValidData}
          onErrorStatus={onErrorStatus}
          useContext={useContext}
        />
      </div>
    );
  }
);

export default CustomFieldSection;
